<template>
    <div class="w-3/4 flex items-center justify-center relative | md:w-auto lg:w-[252px] lg:mr-6">
        <div class="flex items-center flex-shrink-0 h-full flex-col text-3xl w-[52px] pl-1 transition-all ease-in-out duration-1000" :class="{'': isSelecting}">
            <back-line
                class="transition-all ease-in-out duration-1000 z-10"
                :class="{'opacity-0' : isSelecting, 'bg-darkblue-600': disabled}"
                :position="position"
                :total="total"
            />
            <div
                class="flex justify-center items-center w-4 h-4 rounded-full bg-darkblue z-10 transition-all ease-in-out duration-1000"
                :class="{'h-6 w-6': isSelecting || selected, 'bg-darkblue-600': disabled}"
            >
                <icon-configurator-check v-if="selected" class="w-3.5 h-3.5"></icon-configurator-check>
            </div>
        </div>
        <div
            class="flex flex-col justify-center w-44 py-2.5 min-h-[88px] transition-all ease-in-out duration-1000 lg:w-72 lg:min-h-[56px] mlg:py-2"
            :class="{'!min-h-[88px]' : isSelecting }"
        >
            <div class="flex items-center">
                <div class="text-[12px] flex-shrink-0 font-extrabold uppercase leading-[1.5] tracking-[0.55px] text-darkblue" :class="{'text-darkblue-600': disabled}">{{ field.getFieldLabel() }}</div>
                <div class="flex lg:!hidden" :class="{'!hidden': disabled}">
                    <button
                        v-if="hasDescriptions"
                        class="btn-info ml-2"
                        @click="$emit('ShowLearMore'); firstRender = true;"
                        aria-label="Open more information"
                    >
                        <icon-plus class=""/>
                        <span>Info</span>
                    </button>

                    <a v-if="field.video" target="_blank" :href="field.video" class="ml-2 btn-info block">
                        <icon-play/>
                        <span>Video</span>
                    </a>
                </div>
            </div>
            
            <div
                v-show="(isSelecting || selected) && descriptionText"
                class="text-3 max-w-[px] overflow-hidden transition-all ease-in-out duration-1000 mt-2"
                :class="{
                    'max-h-0 !mt-0' : !displayMobileName,
                    'max-h-[40px]': displayMobileName,
                    '!text-darkblue' : isSelecting,
                    '!text-darkblue-600': !isSelecting,
                }"
                v-html="trimWord(descriptionText)"
            >
            </div>
        </div>
        
        <MountingPortal v-if="hasDescriptions" append mountTo="#configurator-field-menu" multiple>
            <side-popup
                :show="showDescription" @close="$emit('HideLearMore')"
                :title="field.label"
                :first-redner="firstRender"
            >
                <filed-options-info :field="field"/>
<!--                <filed-options-descriptions :field="field"/>-->
            </side-popup>
        </MountingPortal>

    </div>

</template>

<script>
import BackLine from "./BackLine";
import IconConfiguratorCheck from "../Icons/IconConfiguratorCheck";
import IconInfo from "../Icons/IconInfo";
import SidePopup from "../SidePopup";
import DescriptionView from "../DescriptionScrollView";
import FiledOptionsDescriptions from "../FiledOptionsDescriptions";
import IconPlus from "../Icons/IconPlus.vue";
import FiledOptionsInfo from "../FiledOptionsInfo.vue";
import IconPlay from "../Icons/IconPlay.vue";

export default {
    name: "ProductFieldInfo",
    components: {
        IconPlay,
        FiledOptionsInfo,
        IconPlus, FiledOptionsDescriptions, DescriptionView, SidePopup, IconInfo, IconConfiguratorCheck, BackLine },
    props: {
        field: {},
        isSelecting: {},
        isMobileView: {},
        selected: {},
        sizes: {},
        selectedDisplayName: {},
        position: {},
        total: {},
        showDescription: {
            default: false
        },
        disabled: Boolean,
    },
    data() {
        return {
            firstRender: false,
        }
    },
    methods: {
        trimWord(text, length = text.length, separator = '...') {
            const words = text.trim().split(' ');

            let sentence = words.slice(0, length).join(' ');
            sentence +=  words.length > length ? separator : '';

            return sentence;
        }
    },
    computed: {
        displayMobileName(){
            // if ( this.sizes?.unit !== '' ) {
            //     return true
            // }
            //
           return this.isSelecting || ( !this.isSelecting && this.isMobileView && this.selected);  
        },
        descriptionText(){
            if (this.isMobileView && this.sizes && this.sizes.unit !== '' ) return `Overall width: ${this.sizes.width} ${this.sizes.unit}  <br> Overall height: ${this.sizes.height} ${this.sizes.unit}`;
            const displayNameAndPrice = this.selected !== null && Number(this.selected.type_price) > 0 ? `${this.selectedDisplayName} - £${this.selected.type_price} ${this.selected.type}` : this.selectedDisplayName;
           return this.selectedDisplayName !== '' && this.isMobileView ? displayNameAndPrice : this.field.field_description; 
        },
        hasDescriptions() {
          return this.field.info ?? false;
            // return this.field.options?.filter(item => {
            //     return item.description.text !== '';
            // }).length ?? false;
        },
    },
}
</script>